import styled from "styled-components";

const NewWrapper = styled.div`
    max-width: 900px;
    margin: 60px auto 30px;
    padding: 30px 20px;
    background-color: #e0f7fa;
    border-radius: 15px;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.4);
`;

const NewHeaderText = styled.h1`
    text-align: center;
    font-size: 32px;
    margin-bottom: 20px;
    color: #00796b;
    font-weight: bold;
`;

const NewTextContent = styled.div`
    font-size: 20px;
    line-height: 1.8;
    color: #424242;

    p {
        margin-bottom: 15px;
    }

    strong {
        color: #00796b;
    }
`;

const TermsAndConditions = () => {
  return (
    <>
      <NewWrapper>
        <NewHeaderText>Neue Nutzungsbedingungen</NewHeaderText>
        <NewTextContent>
          <p>
            Willkommen bei Troniq.news. Durch den Zugriff auf unsere Plattform akzeptieren Sie diese Bedingungen, die jederzeit ohne Vorankündigung aktualisiert werden können. Wir empfehlen Ihnen, diese regelmäßig zu überprüfen, um informiert zu bleiben.
          </p>
          <p>
            <strong>1. Nutzung der Plattform:</strong> Der Nutzer verpflichtet sich, die Plattform ethisch und gemäß den geltenden Gesetzen zu nutzen. Es ist verboten, die Plattform für Aktivitäten zu nutzen, die die Sicherheit oder Integrität der Informationen gefährden könnten.
          </p>
          <p>
            <strong>2. Eigentumsrechte:</strong> Alle Inhalte, einschließlich Texte, Bilder, Logos und Software, sind das ausschließliche Eigentum von Troniq.news und durch das Recht des geistigen Eigentums geschützt.
          </p>
          <p>
            <strong>3. Haftungsbeschränkung:</strong> Troniq.news ist nicht verantwortlich für direkte, indirekte oder Folgeschäden, die aus der Nutzung oder der Unfähigkeit zur Nutzung der Plattform resultieren.
          </p>
          <p>
            <strong>4. Aktualisierungen und Änderungen:</strong> Wir behalten uns das Recht vor, Teile dieser Bedingungen jederzeit ohne Vorankündigung zu ändern, zu aktualisieren oder zu löschen. Die fortgesetzte Nutzung der Plattform impliziert die Akzeptanz dieser Änderungen.
          </p>
          <p>
            <strong>5. Gesetzgebung und Gerichtsbarkeit:</strong> Diese Bedingungen unterliegen dem deutschen Recht. Im Falle von Streitigkeiten unterwerfen sich beide Parteien der ausschließlichen Gerichtsbarkeit der Gerichte in Berlin.
          </p>
          <p>
            Wenn Sie Fragen haben oder weitere Informationen benötigen, zögern Sie nicht, uns zu kontaktieren.
          </p>
        </NewTextContent>
      </NewWrapper>
    </>
  );
};
export default TermsAndConditions;